import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './LandingPage.css';

const FashionAndDesign = () => {
    const openWebsite = () => {
        window.open("https://app.psicopatici.com", "_blank");
    };

    return (
        <div className="bg-black text-white w-100 d-flex flex-column align-items-center" style={{ overflowX: "hidden" }}>
            
            <section className="hero-section-custom purple-gradient-bg text-center w-100 d-flex align-items-center justify-content-center" style={{ minHeight: "50vh", paddingTop: "80px", paddingBottom: "40px" }}>
                <Container>
                    <h1 className="hero-title-main mb-3 text-uppercase">PORTA LA TUA VISIONE NELLA MODA CON PSICOPATICI ITALIA</h1>
                    <p className="hero-subtitle-custom mb-4 mb-md-5 text-white mx-auto" style={{ maxWidth: "800px" }}>
                        Fai brillare la tua visione: noi ti diamo lo spazio, tu ci metti il talento.
                    </p>
                    <button className="button buttonHero py-2 py-md-3 px-4 px-md-5 bg-white text-black fw-bold border-0" onClick={openWebsite}>
                        Candidati ora
                    </button>
                </Container>
            </section>

            <section className="w-100 py-5 px-3 bg-black">
                <Container style={{ maxWidth: "900px" }}>
                    <p className="text-center segoe-semilight opacity-75" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                        Avrai lo spazio per far brillare la tua visione, portare il tuo stile in progetti concreti e
                        diventare parte di un ecosistema che valorizza talento e creatività nel mondo della moda, dando
                        vita a collezioni esclusive personalizzate, contenuti creativi che valorizzano il tuo stile e
                        esperienze uniche di personalizzazione per la nostra community.
                    </p>
                </Container>
            </section>

            <div className="w-100 px-3 py-4 d-flex flex-column align-items-center bg-black">
                <div style={{ maxWidth: "1400px", width: "100%" }}>
                    
                    <div className="mb-5">
                        <h2 className="fw-bolder mb-4 text-center subTitle">Come iniziare a guadagnare come Partner Fashion e Design Addicted?</h2>
                        <Row className="g-4 justify-content-center">
                            {[
                                { title: "Registrati in pochi minuti", desc: "Compila il modulo online, che troverai nella specifica pagina Partner, con i dati richiesti. La tua candidatura verrà valutata entro 24 ore e, se approvata, sarai subito operativo." },
                                { title: "Accedi alla tua dashboard personale", desc: "Se approvata, riceverai via email le tue credenziali per accedere all’area riservata, dove potrai generare il tuo link partner, creare contenuti e monitorare in tempo reale vendite, commissioni e bonus crediti." },
                                { title: "Inizia a guadagnare", desc: "Non ti resta che condividere il tuo link partner con i tuoi follower o con chi vorrai e far crescere la tua rete per iniziare a guadagnare commissioni remunerative su ogni acquisto. I pagamenti saranno trasparenti e puntuali, erogati a cadenza trimestrale." }
                            ].map((item, i) => (
                                <Col lg={4} md={6} key={i}>
                                    <div className="p-4 rounded-4 h-100 dashboard-mockup" style={{ backgroundColor: "#0b0b0b", border: "1px solid #222" }}>
                                        <h3 className="segoe-semibold mb-3 fs-5">{item.title}</h3>
                                        <p className="segoe-semilight opacity-75 mb-0" style={{ fontSize: "15px" }}>{item.desc}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="mb-5">
                        <h2 className="fw-bolder mb-4 text-center subTitle mt-5">Tipologie di commissioni</h2>
                        <Row className="g-4 justify-content-center">
                            {[
                                { range: "Commissione di Appartenenza", value: "Ti verrà riconosciuta per ogni acquisto effettuato da un cliente che avrai portato tu attraverso il tuo link partner.\nOgni cliente da te acquisito genera valore e tu ne ricevi sempre una parte." },
                                { range: "Commissioni di Vendita", value: "Verrà calcolata su ogni acquisto generato attraverso i tuoi contenuti personali, attività promozionali o qualsiasi tua azione volta a sponsorizzare il brand." }
                            ].map((item, i) => (
                                <Col lg={6} md={6} key={i}>
                                    <div className="p-4 rounded-4 h-100 dashboard-mockup" style={{ backgroundColor: "#0b0b0b", border: "1px solid #222" }}>
                                        <h3 className="segoe-semibold mb-3 fs-5">{item.range}</h3>
                                        <p className="segoe-semilight opacity-75 mb-0" style={{ fontSize: "15px", whiteSpace: "pre-line" }}>{item.value}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="mb-5">
                        <h2 className="fw-bolder mb-4 text-center subTitle mt-5">Dettaglio Commissioni</h2>
                        <Row className="g-4 justify-content-center">
                            {[
                                { range: "Da 0–50 acquisti", value: "5% di Commissione di Appartenenza\n10% di Commissione di Vendita" },
                                { range: "Da 51–300 acquisti", value: "6% di Commissione di Appartenenza\n12% di Commissione di Vendita" },
                                { range: "Da 301–1000 acquisti", value: "7% di Commissione di Appartenenza\n14% di Commissione di Vendita" },
                                { range: "Oltre 1000 acquisti", value: "8% di Commissione di Appartenenza\n16% di Commissione di Vendita" }
                            ].map((item, i) => (
                                <Col lg={3} md={6} key={i}>
                                    <div className="p-4 rounded-4 h-100 dashboard-mockup text-center" style={{ backgroundColor: "#0b0b0b", border: "1px solid #222" }}>
                                        <h3 className="segoe-semibold mb-3 fs-5 text-white">{item.range}</h3>
                                        <p className="segoe-semilight opacity-75 mb-0" style={{ fontSize: "15px", whiteSpace: "pre-line" }}>{item.value}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="mb-5">
                        <h2 className="fw-bolder mb-4 text-center subTitle mt-5">Perché diventare Partner Fashion e Design Addicted?</h2>
                        <Row className="g-4 justify-content-center">
                            {[
                                "Candidatura gratuita e veloce.",
                                "Supporto creativo e strategico: asset grafici, supporto operativo per trasformare le tue idee in proposte efficaci e vendibili per raccontare il tuo stile in modo professionale e distintivo.",
                                "Accesso al gestionale Psicopatici: possibilità di monitorare in tempo reale l’andamento dei tuoi contenuti e le conversioni generate.",
                                "Creatività libera e totale autonomia nel processo creativo."
                            ].map((text, i) => (
                                <Col lg={6} md={6} key={i}>
                                    <div className="p-4 rounded-4 h-100 dashboard-mockup d-flex align-items-center" style={{ backgroundColor: "#0b0b0b", border: "1px solid #222" }}>
                                        <p className="segoe-semilight opacity-75 mb-0" style={{ fontSize: "15px" }}>{text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="mb-5">
                        <h2 className="fw-bolder mb-4 text-center subTitle mt-5">I benefici riservati ai nostri partner</h2>
                        <Row className="g-4 justify-content-center">
                            {[
                                "Visibilità ufficiale: Possibilità di essere condiviso sui nostri canali social e piattaforme ufficiali Psicopatici Italia.",
                                "Crescita professionale: La tua idea potrà essere selezionata dal nostro ufficio stile, prodotta e poi venduta sul nostro sito.",
                                "Creazione della tua selezione esclusiva: Usa il configuratore per ideare outfit con prodotti personalizzati da te e abbinamenti da proporre direttamente alla nostra community.",
                                "Esperienze uniche e esclusività: Anteprime ad eventi, campagne, shooting e momenti chiave del brand per vivere l’esperienza in modo autentico e attivo.",
                                "Amplificazione della tua visibilità: attraverso la condivisione sui canali social ufficiali di Psicopatici Italia."
                            ].map((text, i) => (
                                <Col lg={6} md={6} key={i}>
                                    <div className="p-4 rounded-4 h-100 dashboard-mockup d-flex align-items-center" style={{ backgroundColor: "#0b0b0b", border: "1px solid #222" }}>
                                        <p className="segoe-semilight opacity-75 mb-0" style={{ fontSize: "15px" }}>{text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="mb-5">
                        <h2 className="fw-bolder mb-4 text-center subTitle mt-5">Chi può diventare Partner Fashion e Design Addicted?</h2>
                        <Row className="g-3 justify-content-center text-center">
                            {[
                                "Fashion Designer", "Personal Shopper", "Consulenti d’immagine",
                                "Stilisti emergenti", "Appassionati di moda"
                            ].map((text, i) => (
                                <Col lg={4} md={6} key={i}>
                                    <div className="py-3 px-4 rounded-5" style={{ backgroundColor: "#111", border: "1px solid #333" }}>
                                        <p className="fw-bold mb-0 text-white">{text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                </div>
            </div>

            <div className="w-100 py-5 text-center d-flex justify-content-center bg-black">
                <button className="button buttonHero py-2 py-md-3 px-4 px-md-5 bg-white text-black fw-bold border-0" onClick={openWebsite}>
                    Candidati ora
                </button>
            </div>

            <footer className="w-100 py-4 border-top border-secondary bg-black text-center">
                <Container>
                    <p className="mb-0 text-white opacity-50 small">&copy; 2025 Psicopatici Italia. Tutti i diritti riservati.</p>
                </Container>
            </footer>
            
        </div>
    );
};

export default FashionAndDesign;